import { TwoFactorStatus } from '@/enums/two-factor-status.enum'
import { UserState } from '../models'

/**
 * SET INITIAL USER STATE
 */
const initialState: UserState = {
  isLoading: false,
  hasError: false,
  error: '',
  wasDeleted: false,
  wasPasswordReset: false,
  users: [],
  pagination: {
    total: 0,
    limit: 25,
    page: 1,
    pages: 1,
  },
  filters: {
    page: 1,
    limit: 25,
  },
  twoFactorVerified: TwoFactorStatus.INITIAL,
  backupCodes: [],
  secretCode: '',
  currentUser: null,
}

export default initialState
